import { useState } from 'react';
import DSDialog from '../../design-system/DSDialog';
import DSDialogActions from '../../design-system/DSDialogActions';
import DSPrimaryButton from '../../design-system/DSPrimaryButton';
import DSSecondaryButton from '../../design-system/DSSecondaryButton';
import DSBox from '../../design-system/DSBox';
import DSTextField from '../../design-system/DSTextField';
import { DSTypography } from '../../design-system/Typography';
import giftClient, { GiftInformation } from '../../api/gift';
import DSCircularProgress from '../../design-system/DSCircularProgress';
import { KLYDO_BLACK } from '../../consts/colors';

export type EnterClockDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (giftInfo: GiftInformation) => void;
};

const EnterClockDialog = ({
  open,
  onClose,
  onConfirm,
}: EnterClockDialogProps) => {
  const [clockIdf, setClockIdf] = useState('');
  const [clockIsAlreadyOpened, setClockIsAlreadyOpened] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClockIdfChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsError(false);
    setClockIsAlreadyOpened(false);
    setClockIdf(event.target.value);
  };

  const handlePressAdd = async () => {
    try {
      setIsLoading(true);
      const giftInfo = await giftClient.getGift({ clockIdf });
      if (giftInfo?.clockInfo?.registerProduct && !giftInfo?.gift) {
        setClockIsAlreadyOpened(true);
        setIsLoading(false);
        return;
      }
      if (giftInfo) {
        setIsLoading(false);
        onConfirm(giftInfo);
      }
    } catch {
      setIsLoading(false);
      setIsError(true);
    }
  };

  const handleClose = () => {
    setIsError(false);
    setClockIsAlreadyOpened(false);
    onClose();
  };

  return (
    <DSDialog open={open} onClose={handleClose}>
      <DSBox
        sx={{ padding: 3, display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <DSTypography
          sx={{
            fontFamily: 'Gilroy-Medium',
            fontSize: '24px',
            fontWeight: 400,
          }}
        >
          Enter Clock Friendly ID
        </DSTypography>
        <DSTextField
          placeholder="white-hamster-80"
          onChange={handleClockIdfChange}
        />
        {isError && (
          <DSTypography
            sx={{ fontFamily: 'Gilroy-Medium', fontSize: '14px' }}
            color="error"
          >
            Clock ID not found
          </DSTypography>
        )}
        {clockIsAlreadyOpened && (
          <DSTypography
            sx={{ fontFamily: 'Gilroy-Medium', fontSize: '14px' }}
            color="error"
          >
            Clock is already opened
          </DSTypography>
        )}
      </DSBox>
      <DSDialogActions sx={{ justifyContent: 'flex-end', padding: 3, gap: 2 }}>
        <DSSecondaryButton onClick={handleClose}>Cancel</DSSecondaryButton>
        <DSPrimaryButton
          onClick={handlePressAdd}
          disabled={!clockIdf}
          sx={{ padding: '14px 40px' }}
        >
          {isLoading ? (
            <DSCircularProgress size={20} sx={{ color: KLYDO_BLACK }} />
          ) : (
            'Add'
          )}
        </DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default EnterClockDialog;
